import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { useNotify } from '@rad/contexts/notifications';
import { staticForm, adjustForm, formValues, formWithErrors } from '@rad/components/dynamic-form/common';
import { createMeasureRequest } from '../types';
import LayoutForm from '../layouts/form';
const constructForm = () => staticForm([
    [
        {
            'id': 'description',
            'title': 'Description',
            'kind': 'text',
            'value': '',
            'settings': {
                'special': 'multiline',
            },
            'required': true,
        },
    ],
]);
const logic = (_) => (x, _) => {
    switch (x.id) {
        default:
            return { ...x, 'disabled': false };
    }
};
const MeasureRequestScreen = (props) => {
    const notify = useNotify();
    const [stateForm, setForm] = React.useState(constructForm());
    const adjustedForm = adjustForm(logic(undefined))(stateForm);
    const [stateErrors, setErrors] = React.useState(undefined);
    const submit = async (e) => {
        e.preventDefault();
        const [valid, result] = await createMeasureRequest({
            ...formValues(stateForm),
        });
        if (valid) {
            notify({ 'kind': 'success', 'message': 'Measure request submitted successfully!' });
            window.location.hash = `#/`;
        }
        else {
            setErrors(result);
        }
    };
    { /* {measures && values['measure'] && measures.find((x) => x.id === values['measure'])?.description} */ }
    return _jsx(LayoutForm, { title: "Request New Measure", form: formWithErrors(adjustedForm, stateErrors), onChange: setForm, onSubmit: submit });
};
export default MeasureRequestScreen;
